import React from "react";
import Header from "./Header/Header";
import CategoryList from "./CategoryList/CategoryList";
// import Dishes from "./Dishes/Dishes";
// import useDishes from "./hooks/useDishes";
// import { useState } from "react";

function App() {
  
  
  
  return (
    <>
     <Header/>
     <CategoryList/>
    </>
  );
}

export default App;
